<template>

	<!-- Page Container -->
	<div class="page-container">
		
		 <!-- <div class="smoke overlay" :class="smokeVisible ? 'visible' : ''">
	    <video src="https://player.vimeo.com/external/403725192.sd.mp4?s=d4d6342491e6938b0d74981dbdeb32b845f562da&profile_id=164" playsinline="true" autoplay="true" loop="true" id="smoke-out" preload="auto"/>
    </div> -->
    
	  <!-- Main -->
	  <main class="main">
	    
	    	<aside id="schedule-toggle" :class="[open ? 'active grow width' : '', livestreamlocation == 'Full Screen' ? '':'']" @click="handleClick"  style="z-index: 999;">
				<span v-if="!open">Schedule</span>
			</aside>
	    		
	    <!-- Hero - Radical Broadcast -->
			

		<!-- Hero - Livestream -->
			<template v-if="livestreamtoggle == 'on' && livestreamlocation == 'Full Screen'">
				<template v-if="livestreamlocation == 'Radical Broadcast' || livestreamlocation == 'Full Screen'">
				<div class="livestream-rb" :class="[open ? 'sched-open' : '', livestreamlocation == 'Full Screen' ? 'fs':'']">
				<Livestream />
				  <div id="schedule" :class="open ? 'is-open' : ''">
					  <article>
						  <div class="wrap schedule-header">
			          <header>
			            <h2>Live Radical Broadcast</h2>
			            <hr>
			          </header>
				      </div>
						  
						  <div class="wrap schedule-wrap">
							  
							  <main>
									
							      <h2 class="text-extended"><strong>{{livebroadcasttitle}}</strong></h2>
							      <prismic-rich-text :field="livebroadcastcontent" class="collection-description"/>
							      <prismic-link :field="readmorelink" class="cta btn">
							      	<span>Read More</span>
							      </prismic-link>
								</main>
							
						  </div>
						  
					  </article>
				  </div>
				 </div>
			</template>
		</template>
			<template v-else>
				<RadicalBroadcast/>
			</template>
			<div class="ticker bg-black loaded" data-title="Radical Broadcast" style="background-color: black;color: white!important;">
				      	<div>
				      		<marquee-text :duration="60">
				      		  <h3 class="ticker-item fs-normal">Live <span class="text-extended">Broadcast</span></h3>
				      		  <span class="ticker-item performa fs-normal">Performa</span>
										<span class="ticker-item fs-normal date text-mono" v-text="updateToday" />
				      		  <span class="text-condensed ticker-item performa fs-normal">Live <span class="text-extended">Broadcast</span></span>
				      		  <span class="ticker-item performa fs-normal">Performa</span>
				      		</marquee-text>
				      	</div>
				      </div>
			<div class="ticker bg-green loaded ticker-right" data-title="Join Us">
        <div>
            <marquee-text :duration="60">
              <h3 class="ticker-item fs-normal">Join Us</h3>
              <span class="ticker-item performa fs-normal">Performa</span>
              <span class="ticker-item fs-normal">Join Us</span>
              <span class="ticker-item performa fs-normal">Performa</span>
            </marquee-text>
        </div>
    </div>
			<div class="wrap wrap-half homepage-button-wrapper">
				<div style="max-width:960px;margin-left:auto;margin-right:auto;">
				<p class="header-p text-extended">{{ $prismic.richTextAsPlain(fields.byline) }}</p>
			</div>
	    	<prismic-link :field="fields.donate_link" class="btn btn--full" style="text-align: center">{{ fields.donate_text }}</prismic-link>
			</div>

		<!-- SHOP -->
		<article class="shop-container shop wrap" v-if="products.length > 0">

				<div>
					<div class="shop-header">
						<h1>Editions</h1>
					</div>
					<div class="section-description">
						<p>
							For Performa’s 15th Anniversary we asked 6 artists to produce a usable artwork, 
							to be sold exclusively during the November 18, 2020 Telethon. Each have responded 
							in remarkable, unique ways, to create a series of works that can be both used and 
							displayed in the home. Each artist has a strong connection to Performa, either 
							through presenting a Commission in a Biennial, or being a longtime friend and 
							supporter of Performa's work. The editions will be sold exclusively during the 
							Telethon from 5pm - 10pm EST.
							<strong><br></strong>
								Click on the images to BUY starting at 5pm EST, Wednesday, November 18th.
						</p>
					</div>
					<!-- <prismic-rich-text class="shop-header" :field="editions.title" />  -->
					<!-- <prismic-rich-text class="section-description" :field="editions.introText" />  -->

				</div>

				<div class="grid-container c4 products-container">

					<div class="product-card" v-for="product of products" :key="product.id">
						<div class="pgi">
							<img :src="product.selectedImage" class="product-card-image" />
						</div>
						<h3>{{ artistName(product.title) }}</h3>
						<span v-if="product.availableForSale" @click="redirectToProductDetailPage(product)" target="_blank" class="btn tb-btn">
							Buy Now!
						</span>
					</div>
				</div>
		 </article>
	    <!-- Events / News -->

	    <section id="events">
	        <div class="events-wrap">
				        
	            <div id="news" class="week-container wrap wrap-half active">
	                <div class="week-container-header">
	                    <h3 class="text-extended text-center text-largest"><strong>News <span class="text-mono">↓</span></strong></h3>
	                </div>
	                <div class="grid-container" :class="featured_posts.length >= 4 ? 'c3' : featured_posts.length == 3 ? 'c3' : featured_posts.length == 2 ? 'c2' : 'c2'"> 
		                <NewsPost v-for="(item, index) in featured_posts" v-if="index <= 3" :key="item.id" :post="item">
		                </NewsPost>
	                </div>
									<div class="wrap wrap-half text-center">
										<router-link class="btn btn--full" to="/news">
											View More
										</router-link>
									</div>
									

	            </div>
	        </div>
	        <div class="ticker bg-blue loaded" data-title="Events">
	            <div>
	            	<marquee-text :duration="60">
	            	  <h3 class="ticker-item fs-normal">Events</h3>
	            	  <span class="ticker-item performa fs-normal">Performa</span>
	            	  <span class="ticker-item fs-normal date text-mono" v-text="updateToday" />
	            	  <span class="ticker-item performa fs-normal">Performa</span>
	            	</marquee-text>
	            </div>
	        </div>
	        <div class="events-wrap">
	            
	            <div class="week-container wrap wrap-half bt  active">
	                <div class="week-container-header" v-if="upcomingEventsTrue(featured_events)">
	                    <h3 class="text-extended text-center text-largest"><strong>Current and Upcoming Events<span class="text-mono">↓</span></strong></h3>
	                </div>
	                <div class="grid-container c2">
		                <FeaturedPost v-for="(item, index) in featured_events" v-if="upcomingEvents(item.post_date)" :key="item.id" :post="item">
		                </FeaturedPost>
	                </div>
	            </div>
	            
	            <div class="week-container wrap wrap-half bt past-week-container" @click="showEvents" :class="eventsExpanded ? 'active' : ''">
	                <div class="week-container-header" v-if="recentlyPastTrue(featured_events)">
	                    <h3 class="text-extended text-center text-largest"><strong>In The Past <span class="text-mono">↓</span></strong></h3>
	                </div>
	                <div class="grid-container c2">
		                <FeaturedPost v-for="(item, index) in featured_events" v-if="recentlyPast(item.post_date)" :key="item.id" :post="item">
		                </FeaturedPost>
	                </div>
	                <div class="wrap wrap-half text-center" style="padding-top:0">
					        	<router-link to="/special-events" class="btn btn--full">Special Events</router-link>
					        </div>
	            </div>
	        </div>

	    </section>

	    
	    <!-- Magazine -->
	    <section id="magazine">
	        <div class="ticker bg-pink loaded" data-title="Magazine">
	            <div>
	            	<marquee-text :duration="60">
	            	  <h3 class="ticker-item fs-normal">Magazine</h3>
	            	  <span class="ticker-item performa fs-normal">Performa</span>
	            	  <span class="ticker-item fs-normal">Magazine</span>
	            	  <span class="ticker-item performa fs-normal">Performa</span>
	            	</marquee-text>
	            </div>
	        </div>
	        
	        
	        <div class="section-wrap magazine-wrap">
	            <div class="grid-container c2">
		            <FeaturedArticle v-for="(item, index) in featured_articles.slice(0,4)" :key="item.id" :article="item">
								</FeaturedArticle>
	            </div>
	        </div>
	        
	        
	        <div class="wrap wrap-half text-center">
	        	<router-link to="/magazine" class="btn btn--full">View All</router-link>
<!-- 	            <aside class="sponsored-by text-center text-bold fs-1">
	                <span class="text-condensed text-uppercase">With generous support from <span class="text-extended">Gucci</span></span>
	            </aside> -->
	        </div>
	    </section>
			<section id="performa19" class="bg-black">
	    	<div class="ticker ticker-right bg-white loaded" data-title="Events" style="background-color:yellow;">
	    	    <div>
	    	    	<marquee-text :duration="60">
	    	    	  <h3 class="ticker-item fs-normal">November 1 — 24, 2019</h3>
	    	    	  <span class="ticker-item performa fs-normal">Performa•19</span>
	    	    	  <span class="ticker-item fs-normal">November 1 — 24, 2019</span>
	    	    	  <span class="ticker-item performa fs-normal">Performa•19</span>
	    	    	</marquee-text>
	    	    </div>
	    	</div>
	    	    	<div style="background-color: black;color:white;font-size:1.5rem;">
	    	    	<div class="wrap" style="max-width:960px;margin-left:auto;margin-right:auto;">
	    	    		<h3 class="text-extended text-center text-largest text-uppercase"><strong>Performa 19</strong></h3>
	    	    	    <p class="header-p text-extended" style="text-align:justify;hyphens:none;">The eighth edition of the Performa Biennial once again celebrated the extraordinary vitality, inventiveness and significance of New York as a leading global performance capital of the world in three weeks of exciting programming, from November 1 — 24, 2019, at locations throughout New York City.</p>

	    	    	    <br/>
	    							<div class="homepage-button-wrapper">
	    								<a href="http://performa19.org" target="_blank" class="btn btn--full btn--white text-center" style="border: 1px solid white">Click here to view</a>
	    	    				</div>
	    				</div>
	    	    </div>
	    </section>
	  </main>
	</div>

</template>

<style>
.btn--full{
	display: block;
	border: 1px black solid;
	border-radius: 16px;
	margin: 1em auto;
}

.btn{
	display: inline-block;
	border: 1px black solid;
	border-radius: 16px;
	margin: 1em auto;
	padding: 16px;
}

</style>

<script>	
import RadicalBroadcast from '../components/RadicalBroadcast.vue'
import FeaturedBanner from '../components/FeaturedBanner.vue'
import Carousel from '../components/Carousel.vue'
import FeaturedPost from '../components/FeaturedPost.vue'
import NewsPost from '../components/NewsPost.vue'
import FeaturedArticle from '../components/FeaturedArticle.vue'

import Livestream from '../components/Livestream.vue'

// shop config
import config from '../../config.js';
import ShopifyClient from '../services/ShopifyClient'

import prismicDOM from 'prismic-dom'
import moment from 'moment'

const toggleClass = function (target, addRemoveClass, className) {
  if (addRemoveClass === 'addClass') {
    target.classList.add(className);
  } else {
    target.classList.remove(className);
  }
}

export default {
  name: 'Homepage',
  components: {
	  RadicalBroadcast,
	  FeaturedBanner,
	  Carousel,
	  FeaturedPost,
	  NewsPost,
	  FeaturedArticle,
	  Livestream,
  },
  data () {
    return {
		products: [],
	    title: null,
	    description: null,
	    seo_image: null,
	    today: null,
	    
      fields: {
				title: null,
				donate_text: null,
				donate_link: null,
				byline: null
      },
      hero_slices: [],
      featured_events: [],
      featured_posts: [],
      featured_articles: [],
      eventsExpanded: false,
      smokeVisible: false,
      livestreamtoggle: '',
      livestreamlocation: '',
      livebroadcasttitle: null,
      livebroadcastcontent: null,
	  readmorelink: null,
    }
  },
  computed: {
    open () {
      return this.$store.state.schedOpen
	}
  },
  watch: {
  	  open: function (open) {
  		  console.log('sched watcher')
		}
  	},
	methods: {
		// scroll () {
    //   window.onscroll = () => {
    //     if ( document.documentElement.scrollTop > window.innerHeight ) {
    //     	var ele = document.getElementById('smoke-out');
		// 			  ele.play();
	  //       this.smokeVisible = true;
         
    //     } else {
	  //       this.smokeVisible = false
    //     }
    //  	}
  	// },
		handleClick () {
			this.$store.dispatch('toggleSched');
    	},
    			closeSched () {
    	    	this.$store.dispatch('toggleSched')
    	    },
		updateToday() {
      this.updateToday = moment().format('MM•D•YYYY');
    },
		thisWeek(date) {
			var yesterday = moment().subtract(1, 'days');
			var weekAhead = yesterday.clone().add(30, 'days');
			if (moment(date).isBetween(yesterday, weekAhead)) {
				return true;
			}
		},
		upcomingEvents(date) {
			var today = moment();
			if (moment(date).isAfter(today)) {
				return true;
			}
		},
		upcomingEventsTrue(array) {
			var today = moment();
			var yesterday = moment().subtract(1, 'days');
			var arrayLength = array.length;
			var upcoming = [];
			
			for (var i=0; i<arrayLength; i++) {
				if (moment(array[i].post_date).isAfter(yesterday)) {
					upcoming.push(array[i]);
				}
	    } 
	    	    
	    if (upcoming.length > 0) {
		  		return true  
	    } else { return false }
		},
		recentlyPast(date) {
			var today = moment();
			if (moment(date).isBefore(today)) {
				return true;
			}
		},
		recentlyPastTrue(array) {
			var today = moment();
			var arrayLength = array.length;
			var past = [];
			
			for (var i=0; i<arrayLength; i++) {
				if (moment(array[i].post_date).isBefore(today)) {
					past.push(array[i]);
				}
	    } 
	    	    
	    if (past.length > 0) {
		  		return true  
	    } else { return false }
		},
		getPosts () {				
			this.$prismic.client.query(
			  this.$prismic.Predicates.at('document.type', 'post'),
			  { orderings : '[my.post.date desc]', pageSize: 3 } // limit fetch to only 3 articles on HOMEPAGE
			).then((response) => {
				this.featured_posts = response.results;
			})
	  },
		getContent () {
		  this.$prismic.client.getSingle('homepage')
		  	.then((document) => {
			  	this.title = document.data.seo_title;
			  	this.description = 	document.data.seo_description;
			  	this.seo_image = document.data.seo_image.url;
			  	this.hero_slices = document.data.body;
			  	this.featured_events = document.data.featured_posts;
			  	this.featured_articles = document.data.featured_articles;
			  	this.today = moment();
			  	this.livestreamtoggle = document.data.livestream
			  	this.livestreamlocation = document.data.livestreamlocation
			  	this.livebroadcasttitle = document.data.live_broadcast_title
			  	this.livebroadcastcontent = document.data.live_broadcast_content
			  	this.readmorelink = document.data.read_more_link
			  	this.id = document.data.livestream_id
				});
				this.$prismic.client.getSingle('footer').then((document) => {
          this.fields.donate_text = document.data.donate_text;
					this.fields.donate_link = document.data.donate_link;
					this.fields.byline = document.data.byline;
        });
	  },
	  toggleBodyClass(addRemoveClass, className) {
	    const el = document.body;
	    if (addRemoveClass === 'addClass') {
	      el.classList.add(className);
	    } else {
	      el.classList.remove(className);
	    }
	  },
	  showEvents() {
		  this.eventsExpanded = true
	  },

	  artistName (title) {
		const name = title;
		return name ? name : title
		// return title.split(',')[1]
	  },

	  redirectToProductDetailPage (product) {
			let url = "https://performa-artist-editions.myshopify.com/products/";
			switch (product.title) {
				case "Barbara Kruger, Untitled (Vase)":
					url += 'barbara-kruger-vase';
					break;
				case "Cindy Sherman, Untitled (Vanity Mirror)":
					url += 'cindy-sherman-mirror';
					break;
				case "Kia LaBeija x Taína Larot, Ring of Fire; The List is Endless":
					url += 'kia-labeija-art-demands';
					break;
				case "Kia LaBeija, December 1st":
					url += 'kia-labieja-december-1st';
					break;
				case "Kia LaBeija, Untitled (The Spirals that lead to Nowhere)":
					url += 'kia-labeija-duet';
					break;
				case "Korakrit Arunanondchai, Mother Pillow":
					url += 'korakrit-arunondchai-body-pillow';
					break;
				case "Laurie Simmons X David Bers Architects, FlashCube":
					url += 'flashcube-laurie-simmons-x-david-bers';
					break;
				case "Michèle Lamy X Katerina Jebb, Untitled (Plateau / Tray)":
					url += 'michele-lamy-tray';
					break;
				default:
					url += 'all-editions';
					break;
				
			}
			window.open(url, '_blank');
		}
	},
	created () {
	  this.getContent();
		this.getPosts();
		this.updateToday = moment().format('MM•D•YYYY');
		if (!this.$store.state.schedOpenedOnMount && window.innerWidth >= 640) {
			// setTimeout(() => {		
			// 	this.$store.dispatch('toggleSched');
			// }, 2000);
		}
  },
  async mounted() {
	

	  this.toggleBodyClass('addClass', 'template-index');
	    setTimeout(function() {
	  		toggleClass(document.body, 'addClass', 'loaded');
			}, 500);

	this.shopifyClient = new ShopifyClient(config.shopifyDomain, config.shopifyToken);

	await this.shopifyClient.allProducts(products => {
		this.products = products;
	});

  },

  destroyed() {
	  this.toggleBodyClass('removeClass', 'template-index');
  },

  metaInfo () {
	  
	  if (this.description == null) {
		  var description = 'Founded by RoseLee Goldberg in 2004, Performa is the leading organization dedicated to exploring the critical role of live performance in the history of twentieth-century art and to encouraging new directions in performance for the twenty-first century.';
	  } else {
		  	  var description = this.description;
	  }
	  	  
    return {
      title: this.title,
      meta: [
		    {vmid: 'description', name: 'description', content: description},
		    
		    {vmid: 'og:title', property: 'og:title', content: this.title},
		    {vmid: 'og:site_name', property: 'og:site_name', content: 'Performa'},
		    // The list of types is available here: http://ogp.me/#types
		    {vmid:'og:type', property: 'og:type', content: 'website'},
		    // Should be the the same as your canonical link, see below.
		    {vmid:'og:url', property: 'og:url', content: 'https://performa-arts.org/'},
		    // Often the same as your meta description, but not always.
		    {vmid:'og:description', property: 'og:description', content: description},
		    {vmid:'og:image', property: 'og:image', content: this.seo_image},
		    
		
		    {vmid: 'twitter:card', name: 'twitter:card', content: 'summary'},
		    {vmid: 'twitter:site', name: 'twitter:site', content: 'https://performa-arts.org/'},
		    {vmid: 'twitter:title', name: 'twitter:title', content: this.fields.title},
		    {vmid: 'twitter:description', name: 'twitter:description', content: description},
		    {vmid: 'twitter:creator', name: 'twitter:creator', content: '@PerformaNYC'},
				{vmid: 'twitter:image', name: 'twitter:image', content: this.seo_image},
		
		    {vmid: 'itemprop-name', itemprop: 'name', content: this.fields.title},
		    {vmid: 'itemprop-description', itemprop: 'description', content: description}
		  ]
    }
  }
}
</script>